import type { Dre } from "@bookdental/schemas";
import { reais } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";
import { moldura } from "../estilos";

/** Retirada dos sócios, compra de equipamento, empréstimo: mexeram no caixa, não no resultado. */
export function ForaDoResultado({ dre }: { dre: Dre }) {
  const { entradas, saidas } = dre.foraDoResultado;
  if (!entradas.valorCents && !saidas.valorCents) return null;
  const grupos = [
    { titulo: "Saíram", cats: saidas.categorias, sinal: -1 },
    { titulo: "Entraram", cats: entradas.categorias, sinal: 1 },
  ].filter((g) => g.cats.length);
  return (
    <section className={cn(moldura, "p-4")}>
      <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">Mexeram no caixa, não no resultado</h3>
      <p className="mt-0.5 text-xs text-zinc-500 dark:text-muted-foreground">Não são despesa nem receita do mês: investimento, retirada e empréstimo ficam fora do DRE.</p>
      <div className="mt-3 grid gap-4 sm:grid-cols-2">
        {grupos.map((g) => (
          <ul key={g.titulo} className="space-y-1 text-sm">
            <li className="text-[11px] font-semibold uppercase tracking-wide text-zinc-500 dark:text-muted-foreground">{g.titulo}</li>
            {g.cats.map((c) => (
              <li key={c.id} className="flex items-center gap-2">
                <span className="h-2 w-2 shrink-0 rounded-[2px]" style={{ backgroundColor: c.cor || "#A1A1AA" }} />
                <span className="min-w-0 flex-1 truncate text-zinc-700 dark:text-foreground/80">{c.nome}</span>
                <span className="tabular-nums text-zinc-900 dark:text-foreground">{reais(g.sinal * c.valorCents)}</span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </section>
  );
}
